var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cta-banner',{attrs:{"title":_vm.$route.name}}),_c('cta-sponsors',{attrs:{"sponsors":_vm.sponsors,"header":_vm.headerPatrocinadores}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }